document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector(
    '.product__media-wrapper--left-thumbs'
  );

  if (!gallery) return;

  // All thumbnails
  const thumbnails = gallery.querySelectorAll(
    '.thumbnail-list__item'
  );

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', (event) => {
      const targetId = thumbnail.getAttribute('data-target');
      if (!targetId) return;

      const targetMedia = gallery.querySelector(
        `[data-media-id="${targetId}"]`
      );

      if (!targetMedia) return;

      event.preventDefault();

      targetMedia.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
});
